export default __webpack_public_path__ + "static/media/0xb6bcae6468760bc0cdfb9c8ef4ee75c9dd23e1ed.7b0a0f6f.webp";